import React from "react";
import AgentListingPresenter from "./AgentListing.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./AgentListing.type";
import { RootState, TCb, AppNotifications, AgentOutputModel } from "../../../models";
import { NotificationActions } from "../../../store/actions";
import _ from "lodash";
import { APP_ROUTES, INITIAL_FETCHING_PAGINATION_DATA } from "../../../constants";
import { AgentService } from "../../../services";
import { loadCallback, AgentUtil } from "../../../utils";
import { withRouter } from "react-router-dom";
const EMPTY_FILTER: C_States["filter"] = {
  searchValue: "",
};

class AgentListingContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const agentDetailId = this.props.match.params.agentId;

    this.state = {
      visibleAgentDetailId: agentDetailId,
      filter: EMPTY_FILTER,
      statusFilter: {
        publish: true,
        unpublish: true
      },
      statusQuery: [],
      fetchedAgent: INITIAL_FETCHING_PAGINATION_DATA,

      visibleAgentId: undefined,
      visibleAgentForm: null
    };
  }

  openEditAgentFormModal = (agent: AgentOutputModel, agentId?: string) => {
    this.setState({ visibleAgentId: agentId, visibleAgentForm: agent }, () => {
      if (agentId) {
        this.props.history.push(AgentUtil.buildAgentDetailPath(agentId));
      }
    });
  };

  closeEditAgentFormModal = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.AGENT.BASE);
    this.setState({ visibleAgentId: undefined, visibleAgentForm: null }, () => {
      loadCallback(cb?.success);
    });
  };

  onCompleteCreateAgent = () => {
    this.onApplyFilter(false);
  };

  onCompleteUpdateAgent = () => {
    this.onApplyFilter(false);
  }

  onApplyStatusFilter = () => {
    this.onApplyFilter(false);
  }

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  onDeleteAgent = (agentId) => {
    AgentService.deleteAgent(agentId)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.onApplyFilter(false);
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Delete partner success",
          });
          loadCallback(this.props.onComplete_Delete);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete partner failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete partner failed" });
      });
  };

  handleChangeCheckBox = (event) => {
    this.setState({
      statusFilter: ({
        ...this.state.statusFilter,
        [event.target.name]: event.target.checked
      })
    }, () => {
      let statusQuery: string[] = [];
      for (const key in this.state.statusFilter) {
        if (this.state.statusFilter[key] === true) {
          statusQuery.push(key)
        }
      }
      this.setState({ statusQuery })
    });
  };

  clearFilter = () => {
    this.setState({
      statusFilter: {
        publish: false,
        unpublish: false
      },
    })
  }

  onApplyFilter = (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedAgent.loading && loadMore) return;

    this.setState(
      (prevState) => {
        return {
          fetchedAgent: {
            ...prevState.fetchedAgent,
            data: loadMore ? prevState.fetchedAgent.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof AgentService.filterAgents>[0] = {
          page: loadMore ? this.state.fetchedAgent.page + 1 : 1,
          limit: this.state.fetchedAgent.limit,
          searchValue: this.state.filter.searchValue || undefined,
          status: this.state.statusQuery || undefined
        };

        AgentService.filterAgents(query)
          .then((res) => {
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let agent: AgentOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    agent.unshift(...prevState.fetchedAgent.data);
                  }

                  return {
                    fetchedAgent: {
                      ...res.data,
                      data: agent,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.props.actions.enqueueSnackbar({
                type: AppNotifications.ERROR,
                message: "Load data failed",
              });
              this.setState({
                fetchedAgent: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Load data failed",
            });
            this.setState({
              fetchedAgent: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  render() {
    return (
      <AgentListingPresenter
        {...this.props}
        {...this.state}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        handleChangeCheckBox={this.handleChangeCheckBox}
        clearFilter={this.clearFilter}
        onCompleteCreateAgent={this.onCompleteCreateAgent}
        onCompleteUpdateAgent={this.onCompleteUpdateAgent}
        openEditAgentFormModal={this.openEditAgentFormModal}
        closeEditAgentFormModal={this.closeEditAgentFormModal}
        onDeleteAgent={this.onDeleteAgent}
        onApplyStatusFilter={this.onApplyStatusFilter}
      />
    );
  }

  componentDidMount() {
    this.onApplyFilter(false, {
      success: () => {},
    });
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(AgentListingContainer)
);
